import { Link } from 'react-router-dom'
import { useLiveQuery } from 'dexie-react-hooks'
import { banco } from '../../db/banco'
import { logoValido } from '../../lib/imagem'

export default function ListaRepresentadas() {
  const representadas = useLiveQuery(
    () => banco.representadas.filter((r) => r.apagado_em === null).sortBy('nome'),
    [],
  )
  return (
    <section className="p-4 space-y-3">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold text-slate-800">Fornecedoras</h2>
        <Link to="/representadas/nova" className="bg-teal-700 text-white rounded-lg px-3 py-2 text-sm">
          + Nova
        </Link>
      </div>
      {representadas?.length === 0 && (
        <p className="text-sm text-slate-500">Nenhuma fornecedora ainda. Cadastre a primeira!</p>
      )}
      <ul className="space-y-2">
        {representadas?.map((r) => (
          <li key={r.id}>
            <Link to={`/representadas/${r.id}`} className="flex items-center gap-3 bg-white rounded-xl shadow-sm p-3">
              {/* Spec 2026-10-06: logo pequeno, inteiro, fundo branco. */}
              <span className="w-8 h-8 shrink-0 rounded-lg border border-slate-200 bg-white overflow-hidden flex items-center justify-center">
                {logoValido(r.logo)
                  ? <img src={r.logo} alt="" data-testid={`logo-lista-${r.id}`} className="w-full h-full object-contain" />
                  : <span aria-hidden="true" className="text-slate-300">🏭</span>}
              </span>
              <div className="min-w-0">
                <span className="font-medium text-slate-800">{r.nome}</span>
                {r.cnpj && <span className="block text-xs text-slate-500">CNPJ {r.cnpj}</span>}
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  )
}
